/** Display the daily channel code without changing the stored global number. */
export const orderDisplayNumber = (order) => {
  if (typeof order?.displayNumber === "string" && order.displayNumber.trim())
    return order.displayNumber.trim();
  const daily = Number(order?.dailyNumber);
  const prefix = order?.SalesChannel?.identifier;
  if (Number.isInteger(daily) && daily > 0 && typeof prefix === "string" && prefix.trim())
    return `${prefix.trim()}-${daily}`;
  const legacy = order?.number;
  return legacy != null && String(legacy).trim() ? String(legacy) : "Pendiente de código";
};
